// Microphone capture via getUserMedia + MediaRecorder, with an AnalyserNode for the waveform.
// Acquiring the recorder requests mic permission (used for the "mic check" in the prepping state);
// MediaRecorder itself only starts on .start(). Voice-tuned bitrate keeps a 20-minute session
// around ~7MB instead of ~19MB at browser defaults.

const AUDIO_BITS_PER_SECOND = 48000;

export async function createAudioRecorder() {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: { channelCount: 1 } });
  const mime = pickMime();
  const recorder = new MediaRecorder(stream, {
    ...(mime ? { mimeType: mime } : {}),
    audioBitsPerSecond: AUDIO_BITS_PER_SECOND,
  });
  const chunks = [];
  recorder.ondataavailable = (e) => { if (e.data && e.data.size) chunks.push(e.data); };

  // Web Audio analyser for the live level/waveform.
  const AC = window.AudioContext || window.webkitAudioContext;
  const ac = new AC();
  const source = ac.createMediaStreamSource(stream);
  const analyser = ac.createAnalyser();
  analyser.fftSize = 256;
  analyser.smoothingTimeConstant = 0.7;
  source.connect(analyser);

  return {
    analyser,
    start() { if (recorder.state === 'inactive') recorder.start(); },
    async stop() {
      if (recorder.state !== 'inactive') {
        await new Promise((res) => { recorder.onstop = res; recorder.stop(); });
      }
      stream.getTracks().forEach((t) => t.stop());
      if (ac.close) ac.close();
      return new Blob(chunks, { type: recorder.mimeType || mime || 'audio/webm' });
    },
  };
}

function pickMime() {
  const cands = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4'];
  if (!window.MediaRecorder || !MediaRecorder.isTypeSupported) return '';
  return cands.find((c) => MediaRecorder.isTypeSupported(c)) || '';
}
